var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1916 2.08111H11.4151C11.0357 1.03309 10.0418 0.27417 8.86733 0.27417C7.69282 0.27417 6.699 1.03309 6.31954 2.08111H2.54303C1.54921 2.08111 0.736084 2.89424 0.736084 3.88806V18.3436C0.736084 19.3374 1.54921 20.1506 2.54303 20.1506H15.1916C16.1855 20.1506 16.9986 19.3374 16.9986 18.3436V3.88806C16.9986 2.89424 16.1855 2.08111 15.1916 2.08111ZM8.86733 2.08111C9.36424 2.08111 9.77081 2.48768 9.77081 2.98459C9.77081 3.4815 9.36424 3.88806 8.86733 3.88806C8.37042 3.88806 7.96386 3.4815 7.96386 2.98459C7.96386 2.48768 8.37042 2.08111 8.86733 2.08111ZM15.1916 18.3436H2.54303V3.88806H4.34997V6.59847H13.3847V3.88806H15.1916V18.3436Z",
    fill: "#B4C9F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a9f6bf69e91e4f647c58923555902bac.svg";
export { ForwardRef as ReactComponent };